var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/pro-solid-svg-icons";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import Dropdown from "@mui/joy/Dropdown";
import Menu from "@mui/joy/Menu";
import MenuButton from "@mui/joy/MenuButton";
import MenuItem from "@mui/joy/MenuItem";
import { IconMappingModule } from "../iconCorrespondance";
import { faSquare } from "@fortawesome/pro-regular-svg-icons";
export default function Placeholder(_a) {
    var _b;
    var menuItem = _a.menuItem;
    var t = useTranslation(["common"]).t;
    var _c = useState(null), openedMenu = _c[0], setOpenedMenu = _c[1];
    // show or not children's menu
    var toggleMenu = function (item) {
        if (openedMenu === item) {
            setOpenedMenu(null);
        }
        else {
            setOpenedMenu(item);
        }
    };
    useEffect(function () {
        var handleClickOutside = function (event) {
            var _a;
            if (!((_a = event.target) === null || _a === void 0 ? void 0 : _a.closest(".menu-contain"))) {
                setOpenedMenu(null);
            }
        };
        document.addEventListener("click", handleClickOutside);
        return function () { return document.removeEventListener("click", handleClickOutside); };
    }, []);
    var _d = useState(null), hoveredItem = _d[0], setHoveredItem = _d[1];
    return (_jsx("div", __assign({ id: "mega-menu", className: " items-center justify-between hidden w-full md:flex md:w-auto md:order-1" }, { children: (_b = Object.keys(menuItem)) === null || _b === void 0 ? void 0 : _b.map(function (item, key) { return (_jsx(Dropdown, { children: _jsxs("div", __assign({ className: "list-none menu-contain mx-2 ".concat(openedMenu === item ? "open" : "") }, { children: [_jsxs("p", __assign({ className: "menu-contain__label flex justify-start uppercase pt-1 ml-2 relative\n              hover:bg-[#eef1f7] hover:rounded\n            ", onMouseEnter: function () { return setHoveredItem(item); }, onMouseLeave: function () { return setHoveredItem(null); } }, { children: [_jsx("span", __assign({ className: "flex items-center justify-center w-full", style: { paddingLeft: "10px" } }, { children: t("app.".concat(item), {
                                    ns: "common",
                                }) }), key), _jsx(MenuButton, __assign({ sx: {
                                    border: "none",
                                }, onClick: function () { return toggleMenu(item); } }, { children: (openedMenu === item || hoveredItem === item) && (_jsx(FontAwesomeIcon, { icon: openedMenu === item ? faChevronUp : faChevronDown, className: "cursor-pointer top-[5px] text-[var(--colors-label)]" })) }))] })), _jsx(Menu, __assign({ placement: "bottom-end", className: "max-h-[800px] min-w-[200px]", sx: {
                            boxShadow: "none",
                            maxHeight: "80vh",
                            overflowY: "auto",
                        } }, { children: Object.values(menuItem[item]).map(function (i) {
                            return Object.values(i).map(function (m, key) { return (_jsx(MenuItem, __assign({ className: "hover:bg-[#eef1f7] hover:rounded uppercase my-2", sx: {
                                    marginLeft: "10px",
                                    marginRight: "10px",
                                } }, { children: _jsxs("a", __assign({ href: "".concat(process.env.PUBLIC_URL, "/modules/").concat(m.modules.module), title: m.modules.module }, { children: [_jsx(FontAwesomeIcon, { icon: IconMappingModule["".concat(m.modules.module)]
                                                ? IconMappingModule["".concat(m.modules.module)]
                                                : faSquare, className: "mr-4 text-xs" }), _jsx("span", { children: t(m.modules.label) })] })) }), key)); });
                        }) }))] }), key) })); }) })));
}
